// Angular
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'militaryTime',
})
export class MilitaryTimePipe implements PipeTransform {
	transform(value: Date, ...args: unknown[]): unknown {
		var time = value.toLocaleTimeString();

		var dtParts = time.split(':');

		var hours = dtParts[0];
		var minutes = dtParts[1];

		if (hours !== '12' && dtParts[2].includes('PM')) {
			let hoursInt = parseInt(hours) + 12;
			hours = String(hoursInt);
		} else if (hours === '12' && dtParts[2].includes('AM')) {
			hours = '00';
		}

		if (hours.length == 1) {
			hours = '0' + hours;
		}

		return hours + ':' + minutes;
	}
}
